import type { IISORealTimeLMPThresholdForm } from '@/types/eos/alerts/forms'
import type IISORealTimeLMPThreshold from '@/types/eos/alerts/LMPThresholdAlert'
import axios from 'axios'

/**
 * Creates an LMP Threshold Alert.
 *
 * @param alert new LMP Threshold Alert form.
 * @returns the created LMP Threshold Alert.
 */
export const createLMPThresholdAlert = async (form: IISORealTimeLMPThresholdForm) => {
  const res = await axios.post(import.meta.env.VITE_APP_REAL_TIME_LMP_THRESHOLDS_ENDPOINT, form)
  return res.data
}

/**
 * Updates an LMP Threshold Alert.
 *
 * @param alert updated LMP Threshold Alert form.
 * @returns the updated LMP Threshold Alert.
 */
export const updateLMPThresholdAlert = async (form: IISORealTimeLMPThresholdForm) => {
  const res = await axios.put(import.meta.env.VITE_APP_REAL_TIME_LMP_THRESHOLDS_ENDPOINT, form)
  return res.data
}

/**
 * Gets all alerts for a given node (or all nodes if filter not specified).
 *
 * @param node filter for alerts (optional).
 * @returns a list of alerts.
 */
export const getLMPThresholdAlerts = async (node?: string): Promise<IISORealTimeLMPThreshold[]> => {
  const res = await axios.get(import.meta.env.VITE_APP_REAL_TIME_LMP_THRESHOLDS_ENDPOINT, {
    params: {
      node,
    },
  })
  return res.data
}

/**
 * Deletes an LMP Threshold Alert.
 *
 * @param id LMP Threshold Alert ID.
 */
export const deleteLMPThresholdAlert = async (id: number): Promise<void> => {
  await axios.delete(import.meta.env.VITE_APP_REAL_TIME_LMP_THRESHOLDS_ENDPOINT, {
    data: { id },
  })
}
